import React, {Component} from 'react';
import LoginForm from '../../components/form/login-form';
import {bindActionToPromise} from '../../utils/redux-form';
import {connect} from 'react-redux';
import {loginAction} from './modules/login-actions';
import DocumentTitle from '../../components/document-title';

class LoginContainer extends Component {
    render() {
        return (<DocumentTitle>
            <div className="row centered">
                <div className="col-5-12">
                    <LoginForm onSubmit={this.props.actions.login}/>
                </div>
            </div>
        </DocumentTitle>);
    }
}

export default connect(
    null,
    function (dispatch) {
        return {
            actions: {
                login: bindActionToPromise(dispatch, loginAction)
            }
        };
    }
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/js/routes/login/login-container.jsx